module.exports = __webpack_public_path__ + "img/img_013@2x.7114bc3d.png";